
  export default {
    props: {
      attributes: { type: Object, default () { return {}; } },
      icon: { type: String, default: 'circle-info' },
      tooltip: { type: String, default: null }
    },
    computed: {
      tooltipOptions () {
        if (!this.tooltip) {
          return null;
        }
        let opts = { classes: 'listItemTooltip', content: this.tooltip };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    }
  };
